<template>
  <div
    class="modal modal-dialog-centered fade"
    :class="{show: isOpenModal}"
    :style="{display: isOpenModal ? 'block' : 'none'}"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click.prevent="closedModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <slot>
            <h5
              class="modal-title font-open-sans font-semibold color_8d97ad font-20"
            >
              Ви дійсно бажаєте вийти з <br>
              акаунта?
            </h5>
          </slot>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-secondary border-0 shadow-none"
            @click.prevent="closedModal"
          >
            Назад
          </button>
          <button
            type="button"
            class="green-btn font-bold my-2 py-2.5 px-4 rounded"
            @click.prevent="submitModal"
          >
            Вийти
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoutModal',
  props: {
    isOpenModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      appElement: null,
    }
  },
  watch: {
    isOpenModal() {
      if (this.isOpenModal) {
        this.appAddClass()
      } else {
        this.appRemoveClass()
      }
    },
  },
  mounted() {
    this.initialValues()
  },
  methods: {
    closedModal() {
      this.$emit('closed')
    },
    submitModal() {
      this.$emit('submitModal')
    },
    initialValues() {
      this.appElement = document.querySelector('#app')
    },
    appAddClass() {
      this.appElement.classList.add('open-modal')
    },
    appRemoveClass() {
      this.appElement.classList.remove('open-modal')
    },
  },
}
</script>

<style scoped></style>
